<template>
  <div
    :class="'dropDown-option ' + analyticsClass"
    role="button"
    tabindex="0"
    :aria-label="ariaLabelText"
    @click="optionClick"
    v-on:copy="doNotCopyElementText"
    v-on:cut="doNotCopyElementText"
    v-on:keydown.up="onKeyUp"
    v-on:keydown.down="onKeyDown"
    v-bind="dataAttributeOption"
  >
    <div class="required-product-container">
      <div class="option-text">{{ text }}</div>
      <div class="option-required-product">
        <img class="errorIcon" :src="errorIconSrc" />
        <div class="non-icon-option-required-product-text">
          <strong>Requires: {{ requiredPartQuantity }}</strong
          ><NBS />
          <a
            :href="requiredPartUrl"
            :class="'required-product-link ' + analyticsClassRequiredProduct"
            target="_blank"
            rel="noopener noreferrer"
            v-bind="dataAttributeOptionRequiredProduct"
            >{{ requiredPartName }}</a
          ><NBS /> per
          {{ productSkuName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NBS from "../../shared/NonBreakingSpace.vue";

export default {
  props: {
    text: {
      type: String
    },
    value: {
      type: String
    },
    productSkuName: {
      type: String
    },
    requiredPartName: {
      type: String
    },
    requiredPartQuantity: {
      type: String
    },
    requiredPartUrl: {
      type: String
    },
    dropDownId: {
      type: String,
      default() {
        return "";
      }
    },
    dataAttribute: {
      type: String
    },
    dataAttributeValue: {
      type: String
    },
    analyticsClass: {
      type: String
    },
    dataAttributeRequiredProduct: {
      type: String
    },
    dataAttributeValueRequiredProduct: {
      type: String
    },
    analyticsClassRequiredProduct: {
      type: String
    },
    isManufacturerOption: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  methods: {
    optionClick(event) {
      this.$emit("optionClicked", {
        value: this.valueWithDefault,
        dropDownId: this.dropDownId,
        event
      });
    },
    onKeyUp(e) {
      e.preventDefault();
      const previousOption = e.target.parentNode.previousElementSibling;

      if (previousOption) {
        previousOption.querySelector(".dropDown-option").focus();
      }
      // reached the top of the list and want to move to the input
      else {
        this.$nextTick(() => {
          // for the manufacture menu
          if (this.isManufacturerOption) {
            this.$parent.$refs.searchManufacturerInput.focus();
          }
          // for the model menu
          else {
            this.$parent.$refs.searchModelInput.focus();
          }
        });
      }
    },
    onKeyDown(e) {
      e.preventDefault();
      this.$nextTick(() => {
        const nextOption = e.target.parentNode.nextElementSibling;

        if (nextOption) {
          nextOption.querySelector(".dropDown-option").focus();
        }
      });
    },
    doNotCopyElementText(event) {
      event.preventDefault()
    }
  },
  computed: {
    errorIconSrc() {
      return "https://res.cloudinary.com/avd/image/upload/v1661964419/Icons/New%20Design%20Site%20Icons/error.svg";
    },
    valueWithDefault() {
      if (this.value) {
        return this.value;
      } else {
        return this.text;
      }
    },
    ariaLabelText() {
      return `Option ${this.valueWithDefault}`;
    },
    dataAttributeOption() {
      if (this.dataAttribute && this.dataAttributeValue) {
        return {
          [this.dataAttribute]: this.dataAttributeValue.toLowerCase()
        };
      } else {
        return {};
      }
    },
    dataAttributeOptionRequiredProduct() {
      if (
        this.dataAttributeRequiredProduct &&
        this.dataAttributeValueRequiredProduct
      ) {
        return {
          [this.dataAttributeRequiredProduct]:
            this.dataAttributeValueRequiredProduct.toLowerCase()
        };
      } else {
        return {};
      }
    }
  },
  components: {
    NBS
  }
};
</script>

<style lang="scss" scoped>
.dropDown-option {
  display: block;
  min-width: 100%;
  background-color: unset;
  padding-bottom: 16px;
  padding-top: 6px;
  padding-left: 20px;
  &:hover {
    cursor: default;
  }
}
.option-text {
  color: $black85;
  @include hdg();
  @include body_small();
  @media (min-width: $media-min-width-desktop) {
    @include body_standard();
  }
}

.option-required-product {
  @include hdg();
  @include caption();
  display: flex;
  align-items: center;
  background-color: $warning-200;
  border: 1px solid $warning-600;
  min-height: 37px;
  padding-left: 6px;
  padding-right: 6px;
  min-width: 100%;
  @media (min-width: $lg-tablet) {
    min-width: unset;
    max-width: max-content;
  }
}

.required-product-link {
  text-decoration: underline;
  color: $primary;
  &:hover {
    color: $primary-300;
  }

  &:focus {
    color: $primary-300;
    @include focus_outline();
  }
}

.errorIcon {
  margin-right: 6px;
}

.non-icon-option-required-product-text {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 6px;
  margin-top: 6px;
}
</style>
